// ─── Sentry (PILOT-1) ────────────────────────────────────────────────────────
// Must be the first import so Sentry can instrument the app before anything
// else runs.  DSN comes from VITE_SENTRY_DSN env var — never hardcoded.
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  // PII scrubbing: strip guest-identifiable fields before events are sent.
  beforeSend(event) {
    if (event.request?.data) {
      const data = event.request.data as Record<string, unknown>;
      for (const key of ['guestName', 'roomNumber', 'name', 'email', 'phone']) {
        if (key in data) data[key] = '[Filtered]';
      }
    }
    return event;
  },
});

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { DataProvider } from './providers/DataProvider';
import { DemoModeProvider } from './providers/DemoModeProvider';
import { GuestContextProvider } from './context';
import './styles/index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={
      <div style={{ color: '#fff', padding: '2rem', fontFamily: 'sans-serif' }}>
        Something went wrong. Please refresh the page.
      </div>
    }>
      <DemoModeProvider>
        <DataProvider>
          <GuestContextProvider>
            <App />
          </GuestContextProvider>
        </DataProvider>
      </DemoModeProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
